// table-config.service.ts
import { InjectionToken, Signal } from '@angular/core';
import { ChartType } from 'chart.js';
import {
  ExtraBodyParams,
  RowAction,
  ResponseData,
  GlobalAction,
  CellColoring,
  CustomTableCell,
  TableRow,
} from './table.interface';

export interface TableConfig {
  // ========== Common Data ===============
  name: Signal<string>;
  controls: Signal<boolean>;
  static: Signal<boolean>;
  canExport: Signal<boolean>;
  canCopy: Signal<boolean>;
  chartType: Signal<ChartType>;
  canSelect: Signal<boolean>;
  selectOptions: Signal<GlobalAction | undefined>;
  groupCells: Signal<boolean>;
  hasIndexCol: Signal<boolean>;
  actionCol: Signal<RowAction[]>;
  chartColumn: Signal<string | undefined>;
  coloring: Signal<CellColoring | undefined>;
  customCells: Signal<CustomTableCell[]>;
  onRowClick: Signal<((Row: TableRow) => void) | undefined>;
  hasChartView: Signal<boolean>;
  defaultSort: Signal<Record<string, 'asc' | 'desc'> | undefined>;
  DeletedRowsStyle: Signal<boolean>;

  // ========== api-specific Data ===============
  endpoint?: Signal<string>;
  /** Generic extra body parameters to be appended to API request bodies */
  extraBody?: Signal<ExtraBodyParams | undefined>;
  /** When true, filters and getAvailableFilters are not sent to the API */
  skipFilters?: Signal<boolean>;
  /** When true, the global from/to date range is not sent to the API */
  skipDateRange?: Signal<boolean>;


  // ========== static-specific Data ===============
  data?: Signal<ResponseData>;
}

export const TABLE_CONFIG = new InjectionToken<TableConfig>('TABLE_CONFIG');
